export default {
  isLoading: true
};
